import { AllInclusive } from "../../assets/images";
import SingleCerti from "./SingleCerti";

const Certificates = ({ certis, setCerti }) => {
  return (
    <div className="complementary_certificate">
      <h2>Select a Complimentary Certificate</h2>
      <div className="complimentary_inner">
        {certis.length > 0
          ? certis.map((certi) => {
            if (certi.certificateId === "TVIDREAMVAC") {
              return (
                <SingleCerti
                  certiId={certi._id}
                  certiImg={certi.certificateImg || AllInclusive}
                  certificateTitle={certi.certificateTitle}
                  setCerti={setCerti}
                  certiIndentity={certi.certificateId}
                  certiValue={certi}
                />
              );
            }
            return null;
          })
          : "No certificate"}
      </div>
    </div>
  );
};

export default Certificates;
